import { useNavigate } from 'react-router-dom'
import { Alert } from '@components/primitives/Alert.js'
import { EmptyPanel } from '@components/primitives/EmptyPanel.js'
import { PageShell } from '@components/layout/PageShell.js'
import { ModePageHeader } from '@components/layout/ModePageHeader.js'
import { useConfigPage } from '@components/config/useConfigPage.js'
import { DadosObraSection } from '@components/config/DadosObraSection.js'
import { BackupSection } from '@components/config/BackupSection.js'
import { InstallAppSection } from '@components/config/InstallAppSection.js'
import { ExportRelatoriosSection } from '@components/config/ExportRelatoriosSection.js'
import { AvancadoSection } from '@components/config/AvancadoSection.js'
import { ZonaPerigoSection } from '@components/config/ZonaPerigoSection.js'
import { SobreSection } from '@components/config/SobreSection.js'
import { StorageSection } from '@components/config/StorageSection.js'
import { ConfigModals } from '@components/config/ConfigModals.js'
import { ROUTES } from '@utils/constants.js'

export function ConfigPage() {
  const navigate = useNavigate()
  const state = useConfigPage()
  const { config, saved, startEdit, openLimpar } = state

  if (!config) {
    return (
      <PageShell>
        <EmptyPanel
          title='Nenhuma obra configurada'
          description='Complete o onboarding para personalizar sua experiência.'
          actionLabel='Configurar obra'
          onAction={() => navigate(ROUTES.ONBOARDING)}
        />
      </PageShell>
    )
  }

  return (
    <PageShell>
      <ModePageHeader
        title='Configurações'
        subtitle='Dados da obra, backup, exportações e preferências.'
      />

      <div className='cf3-obra-content'>
        {saved && (
          <Alert
            variant='success'
            title='Dados atualizados!'
            message='As configurações da obra foram salvas com sucesso.'
          />
        )}

        <DadosObraSection config={config} onEdit={startEdit} />
        <InstallAppSection />
        <BackupSection
          ultimoBackup={state.ultimoBackup}
          backupMsg={state.backupMsg}
          fileInputRef={state.fileInputRef}
          handleExportarBackup={state.handleExportarBackup}
          handleSelecionarImport={state.handleSelecionarImport}
        />
        <ExportRelatoriosSection />
        <AvancadoSection
          valorMinimoNF={state.valorMinimoNF}
          dataAlvara={state.dataAlvara}
          reservaPct={state.reservaPct}
          dataPrevisaoTermino={state.dataPrevisaoTermino}
          savingConf={state.savingConf}
          savedConf={state.savedConf}
          setValorMinimoNF={state.setValorMinimoNF}
          setDataAlvara={state.setDataAlvara}
          setReservaPct={state.setReservaPct}
          setDataPrevisaoTermino={state.setDataPrevisaoTermino}
          handleSaveConfiguracoes={state.handleSaveConfiguracoes}
        />
        <ZonaPerigoSection onLimpar={openLimpar} />
        <StorageSection />
        <SobreSection />
        <ConfigModals {...state} />
      </div>
    </PageShell>
  )
}
